export enum Kind {
    Promotion,
    Discount
}